import { jsx as _jsx } from "react/jsx-runtime";
import BreadcrumbLinks from "./BreadcrumbLinks";
import cn from "classnames";
const Breadcrumbs = ({ breadcrumbsSettings }) => {
    if (!breadcrumbsSettings || breadcrumbsSettings.links.length < 1) {
        return null;
    }
    else {
        return (_jsx("div", { className: cn("breadcrumbs"), children: _jsx(BreadcrumbLinks, { links: breadcrumbsSettings.links }) }));
    }
};
export default Breadcrumbs;
